<!--
 * @Name: role
 * @Description: 角色管理
 * @Author: xiadongxue
 * @Date: 2021-10-22 17:24:07
 * @Editors: xiadongxue
-->
<template>
<div
    class="role-wrap"
    v-loading="loading">
    <div class="header-icon">
        <div
            class="click-icon add_icon"
            @click="toAddRole"></div>
        <div
            class="click-icon refresh_icon"
            @click="refresh"></div>
        <search
            :data="{
                projectList: projectList
            }"
            :isRole="true"
            :searchForm="searchForm"
            :searchData="filter"
            @submit="toSearch" />
    </div>
    <el-table
        :data="list"
        style="width: 100%"
        stripe
        border>
        <el-table-column
            v-for="item in tableColumn"
            :key="item.prop"
            align="center"
            :prop="item.prop"
            :label="item.label">
            <template v-slot="{row}">
                <template v-if="item.prop === 'createTime'">
                    {{row[item.prop] ? new Date(row[item.prop]).Format("yyyy-MM-dd") : '--'}}
                </template>
                <template v-else>{{row[item.prop]}}</template>
            </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="170">
            <template v-slot="{row}">
                <el-button
                    type="text"
                    @click="toEditRole(row)">编辑</el-button>
                <el-button
                    type="text"
                    @click="deleteRole(row.roleId)">删除</el-button>
                <el-button
                    type="text"
                    @click="menuDisabled(row)">菜单禁用</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog
        v-loading="loading"
        class="role-dialog"
        title="角色信息"
        :visible.sync="visible"
        :modal-append-to-body="false"
        width="900px"
        @close="close">
        <el-form
            label-width="170px"
            ref="form"
            :model="roleData"
            :rules="roleRules">
            <el-form-item
                prop="projectId"
                label="系统名">
                <el-select
                    disabled
                    size="small"
                    v-model="filter.projectId">
                    <el-option
                        v-for="item in projectList"
                        :key="item.projectId"
                        :value="item.projectId"
                        :label="item.projectName" />
                </el-select>
            </el-form-item>
            <el-form-item
                prop="roleName"
                label="角色名称">
                <el-input
                    v-model="roleData.roleName"
                    size="small" />
            </el-form-item>
            <el-form-item
                prop="description"
                label="描述">
                <el-input
                    v-model="roleData.description"
                    size="small" />
            </el-form-item>
            <el-form-item
                prop="userApp"
                :rules="userAppRules"
                label="绑定应用">
                <el-select
                    filterable
                    size="small"
                    @change="changeApp"
                    v-model="roleData.userApp">
                    <el-option
                        v-for="item in appList"
                        :key="item.ssoAppId"
                        :value="item.ssoAppId"
                        :label="item.appName" />
                </el-select>
            </el-form-item>
            <el-form-item
                prop="userAreaList"
                :rules="userAreaListRules"
                v-show="areaList.length"
                label="大区">
                <el-select
                    filterable
                    multiple
                    size="small"
                    v-model="roleData.userAreaList">
                    <el-option
                        v-for="item in areaList"
                        :key="item.areaId"
                        :value="item.areaId"
                        :label="item.areaName" />
                </el-select>
            </el-form-item>
            <el-form-item
                prop="menuIdList"
                label="权限">
                <select-menu
                    :menuList="menuList"
                    :value.sync="roleData.menuIdList" />
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="visible = false"
                size="small">取消</el-button>
            <el-button
                @click="toSubmit"
                size="small"
                type="danger">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import Search from '@/components/Search.vue'
import SelectMenu from './components/SelectMenu.vue'
import {
    getRolesByProjectId,
    getMenuByProject,
    addRole,
    editRole,
    delRole
} from './api'
import {
    mapGetters
} from 'vuex'
export default {
    name: 'roleList',
    components: {
        Search,
        SelectMenu
    },
    computed: {
        ...mapGetters(['projectList', 'projectId', 'appList']),
        userAppRules() {
            return {
                required: this.projectId !== 0,
                message: '请选择',
                trigger: 'change',
            }
        },
        //大区校验规则
        userAreaListRules() {
            return [{
                required: this.projectId !== 0,
                message: '请选择',
                validator: (rule, value, callback) => {
                    if (this.projectId === 0) {
                        callback()
                    } else {
                        if (this.areaList.length && !value.length) {
                            callback(new Error('请选择'))
                        } else {
                            callback()
                        }
                    }

                }
            }]
        }
    },
    data() {
        return {
            loading: false,
            //添加&修改弹窗显示
            visible: false,
            //是否为添加
            add: false,
            //菜单列表
            menuList: [],
            defaultRoleData: {
                roleName: '',
                description: '',
                menuIdList: [],
                userApp: '',
                userAreaList: []
            },
            roleData: {},
            //筛选配置项
            searchForm: [{
                type: 'select',
                key: 'projectId',
                label: '子系统',
                data: 'projectList',
                value: 'projectId',
                name: 'projectName',
                required: true
            }],
            //筛选默认项
            filter: {
                projectId: ''
            },
            //表格数据
            list: [],
            tableColumn: [{
                prop: 'roleName',
                label: '角色名称'
            }, {
                prop: 'description',
                label: '描述'
            }, {
                prop: 'projectName',
                label: '所属项目'
            }, {
                prop: 'createTime',
                label: '创建时间'
            }],
            roleRules: {
                roleName: [{
                    required: true,
                    message: '请输入',
                    trigger: 'change',
                }],
                menuIdList: [{
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                }]
            },
            areaList: []
        }
    },
    created() {
        this.$watch('projectList', val => {
            if (val.length) {
                this.filter.projectId = this.projectId
                this.toSearch(this.filter)
            }
        })
        if (this.projectList.length) {
            this.filter.projectId = this.projectId
            this.toSearch(this.filter)
        }
    },
    methods: {
        //点击查询
        async toSearch(filter) {
            try {
                this.loading = true
                this.filter = JSON.parse(JSON.stringify(filter))
                let {
                    code,
                    result
                } = await getRolesByProjectId(filter)
                if (code === 0) {
                    this.list = result.projectRoles
                }
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        //对应菜单
        async searchMenu() {
            try {
                if (!this.filter.projectId && this.filter.projectId !== 0) {
                    return
                }
                let {
                    code,
                    result
                } = await getMenuByProject({
                    ...this.filter,
                    ssoAppId: this.roleData.userApp
                })
                if (code === 0) {
                    this.menuList = result
                }
            } catch (error) {
                console.log(error)
            }
        },
        //重置
        refresh() {
            this.toSearch(this.filter)
        },
        //删除
        async deleteRole(roleId) {
            try {
                let res = await this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                if (res) {
                    let {
                        code
                    } = await delRole({
                        roleId
                    })
                    if (code === 0) {
                        this.$message.success('删除成功')
                        this.toSearch(this.filter)
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        //菜单禁用
        menuDisabled(row) {
            this.$router.push({
                path: '/manage/menuDisabled',
                query: {
                    roleId: row.roleId,
                    projectId: this.filter.projectId
                }
            })
        },
        //弹窗关闭
        close() {
            this.add = false
            this.roleData = JSON.parse(JSON.stringify(this.defaultRoleData))
            this.areaList = []
            this.$nextTick(this.$refs['form'].clearValidate)
        },
        //点击确定
        toSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    //通过校验
                    this.toSave()
                } else {
                    return false
                }
            });
        },
        //保存
        async toSave() {
            try {
                this.loading = true
                let Fn = editRole
                let data = {
                    roleName: this.roleData.roleName,
                    description: this.roleData.description,
                    menuIdList: this.roleData.menuIdList,
                    projectId: this.filter.projectId,
                    ...this.roleData.userApp ? {
                        userAppList: [{
                            ssoAppId: this.roleData.userApp,
                            areaIdIncluded: this.roleData.userAreaList || []
                        }]
                    } : {}
                };
                if (this.add) {
                    Fn = addRole
                } else {
                    data.roleId = this.roleData.roleId
                }
                let {
                    code
                } = await Fn(data)
                if (code === 0) {
                    this.$message.success(`${this.add ? '添加' : '修改'}成功`)
                    this.toSearch(this.filter)
                    this.visible = false
                    //sso单独处理
                    if (this.filter.projectId === 0) {
                        window.location.reload()
                    }
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },
        //添加角色
        toAddRole() {
            this.visible = true
            this.add = true
        },
        //编辑角色
        toEditRole(row) {
            let userAppParams = row.userAppParams || []
            this.roleData = JSON.parse(JSON.stringify({
                ...row,
                userApp: userAppParams.length && userAppParams[0].ssoAppId || '',
                userAreaList: userAppParams.length && userAppParams[0].areaIdIncluded || [],
                projectId: this.filter.projectId,
                menuIdList: row.menuList
            }))

            if (userAppParams.length) {
                this.areaList = this.appList.find(item => item.ssoAppId === userAppParams[0].ssoAppId).areaList
            }
            this.searchMenu()
            this.visible = true
            this.add = false
        },
        //应用切换
        changeApp(value) {
            //大区关联应用重新获取
            this.areaList = this.appList.find(item => item.ssoAppId === value).areaList
            this.roleData.userAreaList = this.areaList.map(item => item.areaId) || []
            //菜单关联应用重新获取
            this.searchMenu()
            this.roleData.menuIdList = []
        },
    },
    watch: {
        filter: {
            deep: true,
            handler() {
                this.searchMenu()
            }
        }
    }
}
</script>

<style lang="scss">
.role-dialog {

    .el-input,
    .el-select,
    .el-textarea,
    .el-cascader {
        width: 590px;
    }
}
</style>
